import store from "@/store";
import { API, graphqlOperation } from "aws-amplify";
import { GET_TENANT_ALIAS } from "@/store/auth.module";
import * as logger from "@/services/LoggerService.js";

// action types
export const REFRESH_FEATURE_ARRAY = "refreshFeatureArray";
export const VERIFY_FEATURE_ARRAY = "verifyFeatureArray";
export const VERIFY_FEATURE_ASYNC = "verifyFeatureAsync";
export const CLEAR_FEATURE_ARRAY = "clearFeatureArray";

// mutation types
export const RESET_STATE = "resetState";
export const SET_STATE = "setState";

const state = {
  featureArray: [],
  tenantAlias: null
};

const getters = {
  verifyFeature(state) {
    return featureName => {
      return state.featureArray.includes(featureName);
    };
  }
};

const actions = {
  [VERIFY_FEATURE_ARRAY](context) {
    return new Promise(async (resolve, reject) => {
      const currentTenantAlias = await getTenantAlias();

      if (!currentTenantAlias) {
        context.dispatch(CLEAR_FEATURE_ARRAY);
        resolve("No Merchant Id");
        return;
      }

      try {
        if (context.state.tenantAlias !== currentTenantAlias) {
          await context.dispatch(REFRESH_FEATURE_ARRAY, currentTenantAlias);
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  },
  [VERIFY_FEATURE_ASYNC](context, featureName) {
    return new Promise(async resolve => {
      try {
        await context.dispatch(VERIFY_FEATURE_ARRAY);
        const isFeatureEnabled = context.getters.verifyFeature(featureName);
        resolve(isFeatureEnabled);
      } catch (e) {
        resolve(false);
      }
    });
  },
  [REFRESH_FEATURE_ARRAY](context, tenantAlias) {
    return new Promise(async (resolve, reject) => {
      try {
        tenantAlias = !!tenantAlias ? tenantAlias : await getTenantAlias();
        if (!tenantAlias) {
          context.dispatch(CLEAR_FEATURE_ARRAY);
          resolve(true);
          return;
        }
        const featureArray = await retrieveFeatureArray(tenantAlias);
        context.commit(SET_STATE, { featureArray, tenantAlias });
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  },
  [CLEAR_FEATURE_ARRAY](context) {
    context.commit(RESET_STATE);
  }
};

const mutations = {
  [RESET_STATE](state) {
    state = {
      featureArray: [],
      tenantAlias: null
    };
  },
  [SET_STATE](state, newState) {
    state.featureArray = newState.featureArray;
    state.tenantAlias = newState.tenantAlias;
  }
};

async function getTenantAlias() {
  try {
    return await store.dispatch(GET_TENANT_ALIAS);
  } catch (e) {}
  return "";
}

async function retrieveFeatureArray(tenantAlias) {
  let features = [];
  try {
    const getMerchantFeatures = `
            query GetMerchantFeatures(
              $aliasCode: String!
            ) {
              getMerchantFeatures(aliasCode: $aliasCode)
            }
          `;

    const getMerchantFeaturesResponse = await API.graphql({
      ...graphqlOperation(getMerchantFeatures, { aliasCode: tenantAlias })
    });

    features = getMerchantFeaturesResponse.data.getMerchantFeatures;
  } catch (e) {
    logger.error(e);
  }
  return features ?? [];
}

export default {
  state,
  actions,
  mutations,
  getters
};
